export const TOKEN_KEY = "token";
export const TOKEN_KEY_EXPIRATION = "token_expiration";
//TODO: set client id and secret
